import logo from 'assets/img/logo.svg';
import dropDownArrowBlue from 'assets/img/select-arrow-blue.png';
import dropDownArrowGreen from 'assets/img/select-arrow-green.png';

const networkStyleMapOverwrite = {
    '$logoImg': logo,
    '$dropDownArrowBlue': dropDownArrowBlue,
    '$dropDownArrowGreen': dropDownArrowGreen,
    '$btnColor1':'#f6f6f6',
    '$btnColor2':'#f1f1f1',
    '$enabledSubmitBtn':'#4FD300',
    '$disabledSubmitBtn':'#B9DF7E',
    '$topBarHeight':'55px',
    '$signUpFormWidth':'440px',
    '$logoWidth':'262px',
    '$logoHeight':'40px',
    '$logoMargin':'initial',
    '$brand-success' : '#4FD300',
    '$error-text': 'red',
};

export default networkStyleMapOverwrite;